var _path, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 47.7519C39.5655 47.7519 49.7519 37.5655 49.7519 24.9999C49.7519 12.4343 39.5655 2.2479 26.9999 2.2479C14.4343 2.2479 4.24789 12.4343 4.24789 24.9999C4.24789 37.5655 14.4343 47.7519 26.9999 47.7519Z",
    stroke: "url(#paint0_linear_4144_13880)",
    strokeWidth: 2.304
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4144_13880)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0313 3.3999V24.9998L42.3047 9.72641C38.3959 5.8176 32.996 3.39993 27.0313 3.3999Z",
    fill: "url(#paint1_linear_4144_13880)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6 25.0312L27.0002 25.0312L42.2736 40.3046C46.1824 36.3958 48.6 30.9959 48.6 25.0312Z",
    fill: "url(#paint2_linear_4144_13880)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0313 3.3999V24.9998L42.3047 9.72641C38.3959 5.8176 32.996 3.39993 27.0313 3.3999Z",
    fill: "#870D0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6 25.0312L27.0002 25.0312L42.2736 40.3046C46.1824 36.3958 48.6 30.9959 48.6 25.0312Z",
    fill: "#870D0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9686 3.3999V24.9998L11.6952 9.72641C15.604 5.8176 21.004 3.39993 26.9686 3.3999Z",
    fill: "url(#paint3_linear_4144_13880)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5998 24.9683L27.0001 24.9683L42.2734 9.69489C46.1822 13.6037 48.5998 19.0037 48.5998 24.9683Z",
    fill: "url(#paint4_linear_4144_13880)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9686 46.6001L26.9686 25.0002L11.6952 40.2736C15.604 44.1824 21.004 46.6001 26.9686 46.6001Z",
    fill: "url(#paint5_linear_4144_13880)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39989 24.9683L26.9996 24.9683L11.7263 9.69489C7.81751 13.6037 5.39989 19.0037 5.39989 24.9683Z",
    fill: "url(#paint6_linear_4144_13880)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9686 46.6001L26.9686 25.0002L11.6952 40.2736C15.604 44.1824 21.004 46.6001 26.9686 46.6001Z",
    fill: "#870D0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39989 24.9683L26.9996 24.9683L11.7263 9.69489C7.81751 13.6037 5.39989 19.0037 5.39989 24.9683Z",
    fill: "#870D0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0313 46.5996L27.0313 24.9997L42.3047 40.2731C38.3959 44.1819 32.996 46.5996 27.0313 46.5996Z",
    fill: "url(#paint7_linear_4144_13880)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39989 25.0313L26.9996 25.0313L11.7263 40.3046C7.8175 36.3958 5.39989 30.9959 5.39989 25.0313Z",
    fill: "url(#paint8_linear_4144_13880)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4144_13880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.06 24.3987C29.06 25.8309 28.1377 26.9919 26.9999 26.9919C25.8622 26.9919 24.9399 25.8309 24.9399 24.3987C24.9399 22.9666 26.9999 19.3638 26.9999 19.3638C26.9999 19.3638 29.06 22.9666 29.06 24.3987Z",
    fill: "#F4F4F4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4144_13880)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.9999,
    cy: 24.9997,
    rx: 1.38493,
    ry: 1.38493,
    fill: "url(#paint9_linear_4144_13880)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4144_13880",
    x: 0.791887,
    y: 0.519902,
    width: 52.4161,
    height: 52.4162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.728
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4144_13880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4144_13880",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4144_13880",
    x: 12.9399,
    y: 7.36377,
    width: 28.1201,
    height: 31.6279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4144_13880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4144_13880",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4144_13880",
    x: 13.615,
    y: 11.6147,
    width: 26.7699,
    height: 26.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4144_13880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4144_13880",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4144_13880",
    x1: 2.22718,
    y1: 3.3999,
    x2: 48.5999,
    y2: 46.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC191E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4144_13880",
    x1: 25.9096,
    y1: 3.3999,
    x2: 47.2661,
    y2: 17.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4144_13880",
    x1: 48.6,
    y1: 23.9095,
    x2: 34.5319,
    y2: 45.2659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4144_13880",
    x1: 28.0904,
    y1: 3.3999,
    x2: 6.73383,
    y2: 17.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4144_13880",
    x1: 48.5998,
    y1: 26.09,
    x2: 34.5317,
    y2: 4.73358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4144_13880",
    x1: 28.0904,
    y1: 46.6001,
    x2: 6.73383,
    y2: 32.5319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4144_13880",
    x1: 5.39989,
    y1: 26.09,
    x2: 19.468,
    y2: 4.73359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4144_13880",
    x1: 25.9096,
    y1: 46.5996,
    x2: 47.2661,
    y2: 32.5314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4144_13880",
    x1: 5.39989,
    y1: 23.9095,
    x2: 19.468,
    y2: 45.2659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4144_13880",
    x1: 25.4116,
    y1: 23.6147,
    x2: 28.3849,
    y2: 26.3846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC191E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9598"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBonus);
export default __webpack_public_path__ + "static/media/icon_bonus.446defe9b79bc7b970cc3924718158cd.svg";
export { ForwardRef as ReactComponent };